import {parseISO, format, isThisYear} from "date-fns";
import { IconWarning, IconAlert, IconInfo } from "../components/Icons";

export const getFeedEndpoints = feeds => {
    let urls = feeds.map(feedName => {
        return `https://gtfs-realtime.trilliumtransit.com/gtfs-realtime/feed/${feedName}/api/website/current-alerts-for-feed.json`
    });
    return urls;
}

const WARN = "warn";
const ALERT = "alert";
const INFO = "info";

const unknownStates = [
    "Other",
    "Unknown Cause",
    "Unknown Effect"
];

const causeAndEffectStates = {
    "Extra Service": INFO,
    "Demonstration": INFO,
    "Technical Problem": INFO,
    "Modified Service": WARN,
    "Detour": WARN,
    "Reduced Service": WARN,
    "Stop Moved": WARN,
    "Police Activity": WARN,
    "Weather": WARN,
    "Accident": WARN,
    "Construction": WARN,
    "Holiday": WARN,
    "Maintenance": WARN,
    "Medical Emergency": WARN,
    "Strike": WARN,
    "No Service": ALERT,
    "Significant Delays": ALERT
};

const getSeverity = field => {
    if (field in causeAndEffectStates) {
        return causeAndEffectStates[field];
    }
    return WARN;
}

const alertFieldIsKnown = (field) => {
    return !unknownStates.includes(field);
}

const getSeverityIcon = severity => {
    if (severity === WARN) {
        return <IconWarning />;
    }
    if (severity === ALERT) {
        return <IconAlert />;
    }
    if (severity === INFO) {
        return <IconInfo />;
    }
}

export const getSeverityInformation = (cause, effect) => {
    let severity, label;
    if (alertFieldIsKnown(effect)) {
        severity = getSeverity(effect);
        label = `${effect}:`;
    } else if (alertFieldIsKnown(cause)) {
        severity = getSeverity(cause);
        label = `${cause}:`;
    } else {
        severity = WARN;
        label = "";
    }
    let icon = getSeverityIcon(severity);
    return {icon: icon, alertLabel: label};
}

const toDateString = isoString => {
    let alertDate = parseISO(isoString);
    let formatString = 'MMMM do, yyyy';
    // if (isThisYear(alertDate)) {
    //     formatString = 'MMMM do';
    // }
    return format(alertDate, formatString);
}

export const getEffectiveDateText = (start, end) => {
    if (start.is_unbounded && end.is_unbounded) {
        return null;
    }
    if (start.is_unbounded && (!end.is_unbounded)) {
        let endDate = toDateString(end.iso8601);
        return `Expires ${endDate}`;
    }
    if ((!start.is_unbounded) && end.is_unbounded) {
        let startDate = toDateString(start.iso8601);
        return `Effective ${startDate}`;
    }
    let endDate = toDateString(end.iso8601);
    let startDate = toDateString(start.iso8601);
    return `Effective ${startDate} - ${endDate}`;
}



// WEBPACK FOOTER //
// ./utils/index.js